import component from "js/legacy/unavailable-message"

export default component
